import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HonkIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M5.76484 5.06348H2.09998L2.10008 18.9366H5.76494V18.0366C5.76494 17.2073 5.97493 16.2747 6.52199 15.5705C7.03803 14.9062 7.93788 14.3346 9.5757 14.3346H9.66663C9.95107 16.2274 11.3883 17.828 13.3333 17.828C15.2783 17.828 16.7155 16.2274 17 14.3346H20.1V17.1369H21.9L21.9 7.50024H20.1V9.67637H9.5757C7.93923 9.67637 7.03936 9.10312 6.52273 8.43611C5.97493 7.72884 5.76484 6.79295 5.76484 5.96348V5.06348ZM13.3333 16.028C12.5557 16.028 11.7458 15.3838 11.4943 14.3346H15.1723C14.9208 15.3838 14.1109 16.028 13.3333 16.028ZM4.02563 6.86348C4.1456 7.74711 4.45867 8.71074 5.09967 9.53832C5.99909 10.6996 7.45465 11.4764 9.5757 11.4764H20.1V12.5346H9.5757C7.456 12.5346 6.00047 13.3077 5.1005 14.4662C4.45907 15.2919 4.14584 16.2538 4.02579 17.1366H3.90007L3.89999 6.86348H4.02563Z"
      />
    </SvgIcon>
  );
});
